import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import ContentHeader from '@zenbusiness/zui/ContentHeader';
import Text from '@zenbusiness/zui/Text';

import { useDashboardPath } from '#client/hooks/useDashboardPath';

import * as Styled from './FundboxCard.styles';

const SquarespaceDomainsCard = () => {
  const { formatMessage: fm } = useIntl();
  const dashboardPath = useDashboardPath();

  const destination = `${dashboardPath}/money/fundbox`;

  return (
    <Styled.Root>
      <Styled.Image
        alt={fm({ id: 'dashboard.carousel.card.fundbox.imageAlt' })}
        src="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/raster/saving-money-cash.png"
      />
      <Styled.CardContent>
        <ContentHeader
          title={<Text size="md" weight="medium" color="primary"><FormattedMessage id="dashboard.carousel.card.fundbox.title" /></Text>}
          subtitle={<Text size="sm" weight="regular" color="secondary"><FormattedMessage id="dashboard.carousel.card.fundbox.subTitle" /></Text>}
        >
          <Styled.CardButton
            clickstreamProps={{
              elementName: 'carousel_link',
              elementText: 'fundbox',
              destination
            }}
            color="secondary"
            size="sm"
            to={destination}
            endIcon={<ArrowForwardIcon />}
          >
            <FormattedMessage id="dashboard.carousel.card.fundbox.button" />
          </Styled.CardButton>
        </ContentHeader>
        <Styled.CardFooter>
          <Text size="xs" weight="regular" color="tertiary">
            <FormattedMessage id="dashboard.carousel.card.fundbox.footer" />
          </Text>
          <Styled.Logo
            alt={fm({ id: 'dashboard.carousel.card.fundbox.footerLogoAlt' })}
            src="/s2/vector/fundbox-logo.svg"
          />
        </Styled.CardFooter>
      </Styled.CardContent>
    </Styled.Root>
  );
};

export default SquarespaceDomainsCard;
